export const NAME = 'consultationAppoint';